import type { Container, Filter } from 'pixi.js';

export type FilterConstructor<T extends Filter> = new () => T;

export function findOrCreateFilter<T extends Filter>(
  container: Container,
  filterType: FilterConstructor<T>,
  createFilter: () => T,
): T {
  const filters: Filter[] = getFilters(container);
  const filter = filters.find((f) => f instanceof filterType) ?? createFilter();

  if (!filters.includes(filter)) filters.push(filter);
  container.filters = filters;
  return filter as T;
}

export function getFilters(container: Container): Filter[] {
  if (!container.filters) return [];
  return (Array.isArray(container.filters) ? container.filters.slice() : [container.filters]) as Filter[];
}

export function removeFilter(container: Container, filter: Filter): void {
  container.filters = getFilters(container).filter((f) => f !== filter);
}
